import { useState, useCallback, useEffect } from "react";
import { request } from "../../httpClient";

export const useVehicleMarkList = () => {
  const [vehicleMarkListLoading, setVehicleMarkListLoading] = useState(false);
  const [vehicleMarkList, setVehicleMarkList] = useState([]);

  const getVehicleMarkList = useCallback(async () => {
    setVehicleMarkListLoading(true);
    const res = await request({
      path: "vehicle-mark/list",
    });
    setVehicleMarkList(res?.data);
    setVehicleMarkListLoading(false);
    return res?.data;
  }, []);

  useEffect(() => {
    getVehicleMarkList();
  }, []);

  return { vehicleMarkListLoading, vehicleMarkList, getVehicleMarkList };
};
